module.exports = __webpack_public_path__ + "assets/img/highperf.d1afb578.svg";